"use client";

import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";

function cn(...classes: Array<string | false | undefined | null>) {
  return classes.filter(Boolean).join(" ");
}

type TabType = "password" | "magic-link" | "sso";

interface AuthTabsProps {
  activeTab: TabType;
  onTabChange?: (tab: TabType) => void;
}

export function AuthTabs({ activeTab, onTabChange }: AuthTabsProps) {
  const tabs: { key: TabType; label: string }[] = [
    { key: "password", label: "Password" },
    { key: "magic-link", label: "Magic Link" },
    { key: "sso", label: "SSO" },
  ];

  return (
    <div className="mb-6 flex gap-2 rounded-xl border border-white/10 bg-white/[0.03] p-1">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          onClick={() => onTabChange?.(tab.key)}
          className={cn(
            "flex-1 rounded-lg px-4 py-2 text-center text-sm font-medium transition",
            activeTab === tab.key
              ? "bg-emerald-500/10 text-emerald-300 ring-1 ring-emerald-400/20"
              : "text-white/60 hover:bg-white/[0.06] hover:text-white/80"
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

